import { gql } from '@apollo/client';

export default gql`
  {
    Tempos{
        IdTempo
        Tempo
      }
  }
`;